/**
 * 懒加载路由组件
 */
export const lazyLoad = () => {
  return import(/* webpackChunkName: "about" */ "@/components/layout");
};
